var _vars = require('./vars')._vars;
var difyApi = require('./providers/dify/api');
var shared = require('./shared');
var _html = require('./html')._html;
var provider = require('./providers/dify');
var groupedConversations = {};
var lastFetchedOffset;

function escapeHtmlAttr(value) {
    if (value === null || value === undefined) return '';
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function buildInlineCitationMarker(citationNumber, citationUrl) {
    var normalizedNumber = citationNumber !== null && citationNumber !== undefined ? String(citationNumber).trim() : '';
    if (!normalizedNumber) {
        return '';
    }
    var urlAttr = citationUrl ? ' data-citation-url="' + escapeHtmlAttr(citationUrl) + '"' : '';
    return '<span class="citation-circle inline-citation-marker" role="button" tabindex="0" aria-label="Open citation ' +
        escapeHtmlAttr(normalizedNumber) +
        '" data-citation-number="' +
        escapeHtmlAttr(normalizedNumber) +
        '"' +
        urlAttr +
        '>' +
        normalizedNumber +
        '</span>';
}
// Utility to show error message for preserved context
function showPreservedContextError() {
	const container = document.querySelector('.ai-search-asking');
	if (container && !document.querySelector('.preserved-context-error')) {
		const errorDiv = document.createElement('div');
		errorDiv.className = 'preserved-context-error';
		errorDiv.style.margin = '10px 0';
		errorDiv.style.display = 'flex';
		errorDiv.style.alignItems = 'center';
		errorDiv.textContent = 'Failed to load history. Please try again';

		container.insertAdjacentElement('beforebegin', errorDiv);
	}
}

function processMarkdownAnswer(answer) {
    if (!answer || typeof answer !== 'string') return answer;
    
    var processedContent = answer;
    
    // Process HTML entities first (same as streaming)
    processedContent = processedContent.replace(/&gt;/g, '<br>');
    processedContent = processedContent.replace(/<br\s*\/?>/gi, '<br>');
    processedContent = processedContent.replace(/&lt;br&gt;/gi, '<br>');
    processedContent = processedContent.replace(/&lt;br\/&gt;/gi, '<br>');
    processedContent = processedContent.replace(/&lt;br \/&gt;/gi, '<br>');
    processedContent = processedContent.replace(/&lt;/g, '<');
    processedContent = processedContent.replace(/&amp;/g, '&');
    processedContent = processedContent.replace(/&quot;/g, '"');
    processedContent = processedContent.replace(/&#39;/g, "'");
    
    // Handle citations FIRST (same order as streaming) - this prevents citations from being converted to hyperlinks
    // First handle double bracket citations [[number]](url)
    var doubleBracketWithUrlRegex = /\[\[(\d+)\]\]\(([^)]+)\)/g;
    processedContent = processedContent.replace(doubleBracketWithUrlRegex, function(match, citationNumber, citationUrl) {
        return buildInlineCitationMarker(citationNumber, citationUrl);
    });

    // Then handle single bracket citations [number](url)
    var singleBracketWithUrlRegex = /\[(\d+)\]\(([^)]+)\)/g;
    processedContent = processedContent.replace(singleBracketWithUrlRegex, function(match, citationNumber, citationUrl) {
        return buildInlineCitationMarker(citationNumber, citationUrl);
    });

    // Handle [[number]] (no url)
    var doubleBracketOnlyRegex = /\[\[(\d+)\]\]/g;
    processedContent = processedContent.replace(doubleBracketOnlyRegex, function(match, citationNumber) {
        return buildInlineCitationMarker(citationNumber);
    });

    // Handle [number] (no url) - only if not already processed
    var singleBracketOnlyRegex = /\[(\d+)\]/g;
    processedContent = processedContent.replace(singleBracketOnlyRegex, function(match, citationNumber) {
        return buildInlineCitationMarker(citationNumber);
    });

    // Process hyperlinks for non-numeric text [text](url) AFTER citations (same as streaming)
    var textHyperlinkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    processedContent = processedContent.replace(textHyperlinkRegex, function(match, linkText, linkUrl) {
        // Skip if this is a numeric citation - should already be processed above
        if (/^\d+$/.test(linkText.trim())) {
            return match; // Return unchanged for numeric patterns (shouldn't happen at this point)
        }
        // Convert non-numeric text to clean hyperlink
        return '<a style="text-decoration:none; cursor:pointer;" href="' + linkUrl + '" onclick="event.preventDefault(); window.open(\'' + linkUrl + '\', \'_blank\');">' + linkText + '</a>';
    });
    
    // Convert markdown headers to HTML — AC2: H3 uses <b> not <strong> to match AI modal markup
    processedContent = processedContent.replace(/^### \*\*(.*?)\*\*$/gm, '<h3><b>$1</b></h3>');
    processedContent = processedContent.replace(/^### (.*?)$/gm, '<h3><b>$1</b></h3>');
    processedContent = processedContent.replace(/^## \*\*(.*?)\*\*$/gm, '<h2><b>$1</b></h2>');
    processedContent = processedContent.replace(/^## (.*?)$/gm, '<h2>$1</h2>');
    processedContent = processedContent.replace(/^# \*\*(.*?)\*\*$/gm, '<h1><b>$1</b></h1>');
    processedContent = processedContent.replace(/^# (.*?)$/gm, '<h1>$1</h1>');
    
    // Convert markdown bold and italic (same as streaming)
    processedContent = processedContent.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    processedContent = processedContent.replace(/(^|[^*])\*([^*]+)\*(?!\*)/g, function(m, pre, content){
        return pre + '<i>' + content + '</i>';
    });
    
    // Process markdown tables using bindui
    try {
        var bindui = require('./bindui');
        processedContent = bindui.processMarkdownTables(processedContent);
    } catch (error) {
        console.error('Error processing markdown tables:', error);
    }
    
    return processedContent;
}

function renderHistoryInChatInterface(conversationId) {
    var conversationHistory = null;
	var token = null;
    var preservedError = document.querySelector('.preserved-context-error');
	if (preservedError) {
		preservedError.remove();
	}
    var fullWidthEl = document.querySelector('.ai-search-full-width-container');
    var landingPage = document.querySelector('.landing-page');
    if(landingPage) {
        shared.switchToConversationPage(fullWidthEl);
    }
    if(!_vars.token) {
        difyApi.generateToken().then(function(tokenJSON) {
            token = 'Bearer ' + tokenJSON.token;
            _vars.token = token;
            renderHistoryInChatInterface(conversationId);
        }).catch(function() {
            showPreservedContextError();
        });
        return;
    }

    shared.getConversationHistory(conversationId).then(function(response) {
        // Check for missing or empty data
        if (!response || !response.data || response.data.length === 0) {
            showPreservedContextError();
            return;
        }
        document.querySelector('#ai-search-input-modal').placeholder = 'Ask follow up';
        // Render questions and answers from conversationHistory.data
        conversationHistory = response;
        var historyList = document.querySelector('.ai-search-asking');
        if (Array.isArray(conversationHistory.data)) {
            conversationHistory.data.forEach(function(item) {
                historyList.insertAdjacentHTML('beforebegin', '<div class ="ai-search-question ai-search-asking-question active"><span>' + (item.query || '') + '</span></div>');
                
                let answer = '\n\n' + item.answer || '';
                
                // Process the answer with proper markdown formatting
                answer = processMarkdownAnswer(answer);
                
                // Process key points if available
                var summaryBullets = null;
                if (item.key_points && typeof item.key_points === 'string') {
                    var keyPointsText = item.key_points.trim();
                    if (keyPointsText) {
                        // Split by newlines and filter out empty lines
                        var bullets = keyPointsText.split('\n')
                            .map(function(line) { return line.trim(); })
                            .filter(function(line) { return line.length > 0 && line.startsWith('-'); })
                            .map(function(line) { 
                                var processedLine = line.substring(1).trim(); // Remove the leading '-'
                                
                                // Process citations in key points (same as streaming)
                                // First handle double bracket citations [[number]](url)
                                var doubleBracketWithUrlRegex = /\[\[(\d+)\]\]\(([^)]+)\)/g;
                                processedLine = processedLine.replace(doubleBracketWithUrlRegex, function(match, citationNumber, citationUrl) {
                                    return buildInlineCitationMarker(citationNumber, citationUrl);
                                });

                                // Then handle single bracket citations [number](url)
                                var singleBracketWithUrlRegex = /\[(\d+)\]\(([^)]+)\)/g;
                                processedLine = processedLine.replace(singleBracketWithUrlRegex, function(match, citationNumber, citationUrl) {
                                    return buildInlineCitationMarker(citationNumber, citationUrl);
                                });

                                // Handle [[number]] (no url)
                                var doubleBracketOnlyRegex = /\[\[(\d+)\]\]/g;
                                processedLine = processedLine.replace(doubleBracketOnlyRegex, function(match, citationNumber) {
                                    return buildInlineCitationMarker(citationNumber);
                                });

                                // Handle [number] (no url) - only if not already processed
                                var singleBracketOnlyRegex = /\[(\d+)\]/g;
                                processedLine = processedLine.replace(singleBracketOnlyRegex, function(match, citationNumber) {
                                    return buildInlineCitationMarker(citationNumber);
                                });

                                // Process hyperlinks for non-numeric text [text](url)
                                var textHyperlinkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
                                processedLine = processedLine.replace(textHyperlinkRegex, function(match, linkText, linkUrl) {
                                    // Skip if this is a numeric citation - should already be processed above
                                    if (/^\d+$/.test(linkText.trim())) {
                                        return match; // Return unchanged for numeric patterns
                                    }
                                    // Convert non-numeric text to clean hyperlink
                                    return '<a style="text-decoration:none; cursor:pointer;" href="' + linkUrl + '" onclick="event.preventDefault(); window.open(\'' + linkUrl + '\', \'_blank\');">' + linkText + '</a>';
                                });

                                return processedLine;
                            });
                        
                        if (bullets.length > 0) {
                            summaryBullets = bullets;
                        }
                    }
                }

                var keyPointsHtml = '';
                if (summaryBullets && Array.isArray(summaryBullets) && summaryBullets.length > 0) {
                    keyPointsHtml = _html.keyPointsCard(summaryBullets);
                }
                
                historyList.insertAdjacentHTML(
                    'beforebegin',
                    '<div class="ai-search-answer active"><div class="answer">' + keyPointsHtml + '<div class="answer-content">' + answer + '</div></div><div class="ai-search-rating"><span class="ai-search-like">Like</span> <span class="ai-search-dislike">Dislike</span><span class="ai-search-copy" aria-label="Copy conversation">Copy</span></div></div>'
                );
                var lastAnswer = document.querySelectorAll('.ai-search-rating');
                lastAnswer = lastAnswer[lastAnswer.length - 1];
                if(item.follow_up_questions && item.follow_up_questions.length > 0) {
                    provider.renderFollowUpQuestions(item.follow_up_questions);
                }
                if(item.sources && item.sources.length>0) {
                    var refHtml = '';
                    item.sources.forEach(function(source, index) {
                        var displayNumber = source.identification_url || (index + 1);
                        var sourceTitle = source.title_chunk || source.title || 'Reference';
                        var sourceUrl = source.source_url || '#';
                        var metadataText = (source.source_details && typeof source.source_details === 'string') 
                            ? source.source_details.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>') 
                            : '';
                        refHtml += _html.referenceItem(displayNumber, sourceTitle, sourceUrl, metadataText);
                    });
                    lastAnswer.insertAdjacentHTML('afterend', _html.referencesHeading());
                    var referencesSection = lastAnswer.parentNode.querySelector('.references-section');
                    referencesSection.insertAdjacentHTML('beforeend', refHtml);
                }
            });

            shared.processTablesInDOM();
            
            var allAnswerEls = document.querySelectorAll('.answer-content');
            var introEl = allAnswerEls.length > 0 ? allAnswerEls[0] : null;
            if (introEl) {
                setTimeout(function() {
                    requestAnimationFrame(function() {
                        var target = introEl;
                        var scrollContainer = document.querySelector('.ai-search-content');
                        if (target && scrollContainer) {
                            var targetRect = target.getBoundingClientRect();
                            var containerRect = scrollContainer.getBoundingClientRect();
                            var scrollOffset = targetRect.top - containerRect.top + scrollContainer.scrollTop;
                            scrollContainer.scrollTo({ top: scrollOffset, behavior: 'smooth' });
                        } else if (target) {
                            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    });
                }, 300);
            } else {
                shared.scrollToBottom();
            }
            document.querySelector('.ai-search-content').removeEventListener('scroll', shared.handleDifyContentScroll);
            document.querySelector('.ai-search-content').addEventListener('scroll', shared.handleDifyContentScroll);
            // Initialize delegated rating listeners (prevents duplicate tracking calls)
            shared.initDelegatedRatingListeners();
        }

    })
}

function renderHistoryList(history) {
    // Group conversations by month
    history.data.forEach(function(conversation) {
        var date = new Date(conversation.created_at * 1000);
        var currentDate = new Date();
        var monthYear;
        
        if (date.getMonth() === currentDate.getMonth() && date.getFullYear() === currentDate.getFullYear()) {
            monthYear = 'This Month';
        } else {
            monthYear = date.toLocaleString('default', { month: 'long', year: 'numeric' });
        }
        
        if (!groupedConversations[monthYear]) {
            groupedConversations[monthYear] = [];
        }
        groupedConversations[monthYear].push(conversation);
    });

    // Clear existing content
    var historyPanel = document.querySelector('.history-panel');
    var existingList = historyPanel.querySelector('.conversation-list');
    if (existingList) {
        existingList.remove();
    }

    // Create conversation list container
    var conversationList = document.createElement('div');
    conversationList.className = 'conversation-list';

    if (Object.keys(groupedConversations).length === 0) {
        // Show empty state
        var emptyState = document.createElement('div');
        emptyState.className = 'empty-state';
        emptyState.innerHTML = '<div class="empty-state-message">' +
            'Start a conversation to see it here!' +
            '</div>';
        conversationList.appendChild(emptyState);
    } else {
        // Render conversations grouped by month
        Object.keys(groupedConversations).forEach(function(monthYear) {
            var conversations = groupedConversations[monthYear];
            var monthSection = document.createElement('div');
            monthSection.className = 'month-section';
            monthSection.innerHTML = '<div class="month-header">' + monthYear + '</div>' +
                '<div class="month-conversations"></div>';

            var monthConversations = monthSection.querySelector('.month-conversations');
            conversations.forEach(function(conversation) {
                var conversationItem = createConversationItem(conversation);
                monthConversations.appendChild(conversationItem);
            });

            conversationList.appendChild(monthSection);
        });
    }

    // Append the list to history panel
    historyPanel.appendChild(conversationList);
    var spinnerHtml = '<div class="history-panel-spinner"><div class="progress-spinner active"><div></div><div></div><div></div><div></div></div></div>';
    historyPanel.insertAdjacentHTML('beforeend', spinnerHtml);

    // Setup lazy loading if more conversations exist
    setupLazyLoading(history, conversationList, groupedConversations);
}
function truncateText(text) {
    return text.length > 50 ? text.substring(0, 50) + '...' : text;
}
function createConversationItem(conversation) {
    var conversationItem = document.createElement('div');
    conversationItem.className = 'conversation-item';
    conversationItem.setAttribute('data-thread-id', conversation.thread_id);
    conversationItem.innerHTML = 
        '<div class="conversation-title" style="-webkit-box-orient: vertical" title="' + conversation.name + '">' +
            conversation.name +
        '</div>' +
        '<div class="conversation-actions">' +
            '<button class="action-menu" aria-label="Conversation actions">' +
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<path d="M8 3C8.55228 3 9 2.55228 9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2C7 2.55228 7.44772 3 8 3Z" fill="#161B1D"/>' +
                    '<path d="M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z" fill="#161B1D"/>' +
                    '<path d="M8 15C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15Z" fill="#161B1D"/>' +
                '</svg>' +
            '</button>' +
            '<div class="action-dropdown">' +
                '<button class="rename-action">'+
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.7929 0.499986C12.1834 0.10946 12.8166 0.109462 13.2071 0.499986L15.5 2.79288C15.8905 3.1834 15.8905 3.81657 15.5 4.20709L4 15.7071C3.81246 15.8946 3.55811 16 3.29289 16H1C0.447715 16 0 15.5523 0 15V12.7071C0 12.4419 0.105357 12.1875 0.292893 12L11.7929 0.499986ZM10.7071 2.99999L13 5.29288L14.7929 3.49999L12.5 1.20709L10.7071 2.99999ZM12.2929 5.99999L10 3.70709L1 12.7071V15H3.29289L12.2929 5.99999Z" fill="#064AA7"/>'+
                '</svg> Rename</button>' +
                '<button class="delete-action">'+
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 1.00003C3.5 0.447746 3.94772 3.05176e-05 4.5 3.05176e-05H11.5C12.0523 3.05176e-05 12.5 0.447746 12.5 1.00003V2.50003H15.5C15.7761 2.50003 16 2.72389 16 3.00003C16 3.27617 15.7761 3.50003 15.5 3.50003H14V15C14 15.5523 13.5523 16 13 16H3C2.44772 16 2 15.5523 2 15V3.50003H0.5C0.223858 3.50003 0 3.27617 0 3.00003C0 2.72389 0.223858 2.50003 0.5 2.50003H3.5V1.00003ZM4.5 2.50003H11.5V1.00003H4.5V2.50003ZM3 3.50003V15H13V3.50003H3ZM6 5.50003C6.27614 5.50003 6.5 5.72389 6.5 6.00003V12.5C6.5 12.7762 6.27614 13 6 13C5.72386 13 5.5 12.7762 5.5 12.5V6.00003C5.5 5.72389 5.72386 5.50003 6 5.50003ZM10 5.50003C10.2761 5.50003 10.5 5.72389 10.5 6.00003V12.5C10.5 12.7762 10.2761 13 10 13C9.72386 13 9.5 12.7762 9.5 12.5V6.00003C9.5 5.72389 9.72386 5.50003 10 5.50003Z" fill="#064AA7"/>'+
                '</svg> Delete</button>' +
            '</div>' +
        '</div>';

    // Add click handler for conversation
    conversationItem.addEventListener('click', function(e) {
        // Skip if clicking within rename input
        if (_vars.pending || e.target.classList.contains('rename-input')) {
            return;
        }
        
        if (!e.target.closest('.conversation-actions')) {
            wmdPageLink('ai-search_old-conv', this);
            _vars.conversationId = this.getAttribute('data-thread-id');
            var historyBtn = document.querySelector('.history_btn');
            historyBtn.style.display = 'flex';
            document.querySelector('.history-panel').classList.remove('active');
            document.querySelectorAll('.ai-search-content .ai-search-question, .ai-search-content .ai-search-answer,.ai-search-content .ai-search-asking-question').forEach(function(el){
                el.remove();
            });
            // Load conversation
            renderHistoryInChatInterface(_vars.conversationId);
        }
    });

    return conversationItem;
}

function setupLazyLoading(history, conversationList, groupedConversations) {
    if (history.has_more) {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    // Load more conversations
                    var lastKey = Object.keys(groupedConversations).pop();
                    var lastIndex = groupedConversations[lastKey].length - 1;
                    var currentOffset = groupedConversations[lastKey][lastIndex].thread_id;
                    if(lastFetchedOffset && lastFetchedOffset === currentOffset) {
                        return;
                    }
                    var spinnerEl = document.querySelector('.history-panel-spinner');
                    spinnerEl.classList.add('loading');
                    lastFetchedOffset = currentOffset;
                    difyApi.getAllHistory(currentOffset).then(function(response) {
                        if (response.data && response.data.length > 0) {
                            // Group new conversations by month
                            response.data.forEach(function(conversation) {
                                var date = new Date(conversation.created_at * 1000);
                                var currentDate = new Date();
                                var monthYear;
                                
                                if (date.getMonth() === currentDate.getMonth() && date.getFullYear() === currentDate.getFullYear()) {
                                    monthYear = 'This Month';
                                } else {
                                    monthYear = date.toLocaleString('default', { month: 'long', year: 'numeric' });
                                }
                                
                                if (!groupedConversations[monthYear]) {
                                    groupedConversations[monthYear] = [];
                                    // Create new month section
                                    var monthSection = document.createElement('div');
                                    monthSection.className = 'month-section';
                                    monthSection.innerHTML = 
                                        '<div class="month-header">' + monthYear + '</div>' +
                                        '<div class="month-conversations"></div>';
                                    conversationList.appendChild(monthSection);
                                }
                                
                                groupedConversations[monthYear].push(conversation);
                                
                                // Add conversation item to appropriate month section
                                var monthSections = conversationList.querySelectorAll('.month-section');
                                var monthSection = null;
                                for (var i = 0; i < monthSections.length; i++) {
                                    if (monthSections[i].querySelector('.month-header').textContent === monthYear) {
                                        monthSection = monthSections[i];
                                        break;
                                    }
                                }
                                var monthConversations = monthSection.querySelector('.month-conversations');
                                var conversationItem = createConversationItem(conversation);
                                monthConversations.appendChild(conversationItem);
                            });
                            
                            // Update observer target if there are more conversations
                            if (response.has_more) {
                                observer.disconnect();
                                var lastMonth = document.querySelector('.month-section:last-child').querySelector('.conversation-item:last-child');
                                if (lastMonth) {
                                    observer.observe(lastMonth);
                                }
                            } else {
                                observer.disconnect();
                            }
                        }
                        spinnerEl.classList.remove('loading');
                    }).catch(function(error) {
                        spinnerEl.classList.remove('loading');
                        lastFetchedOffset = '';
                    });
                }
            });
        }, {
            root: null,
            rootMargin: '0px 0px 100px 0px',
            threshold: 0
        });

        var lastMonth = document.querySelector('.month-section:last-child').querySelector('.conversation-item:last-child');
        if (lastMonth) {
            observer.observe(lastMonth);
        }
    }
}

function showDeleteConfirmationModal(threadId, conversationTitle, conversationItem) {
    // Create modal overlay
    var overlay = document.createElement('div');
    overlay.className = 'history-delete-overlay active';
    
    // Create modal content
    var modal = document.createElement('div');
    modal.className = 'historyDeleteDrawer';
    modal.innerHTML = 
        '<button class="drawer-close-btn" aria-label="Close"></button>' +
        '<h3>Delete conversation?</h3>' +
        '<div class="button-group">' +
            '<button class="cancel-btn">Cancel</button>' +
            '<button class="confirm-btn">Confirm</button>' +
        '</div>';
    
    overlay.appendChild(modal);
    document.querySelector('.ai-search-full-width-container').appendChild(overlay);
    
    // Handle modal interactions
    var closeModal = function() {
        overlay.remove();
    };
    
    var confirmDelete = function() {
        difyApi.deleteThread(threadId).then(function(response) {
            if (response) {
                conversationItem.remove();
                closeModal();
            }
        }).catch(function(error) {
            console.error('Failed to delete thread:', error);
            closeModal();
        });
    };
    
    // Event listeners
    modal.querySelector('.drawer-close-btn').addEventListener('click', closeModal);
    modal.querySelector('.cancel-btn').addEventListener('click', closeModal);
    modal.querySelector('.confirm-btn').addEventListener('click', confirmDelete);
    
    // Close on overlay click
    overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
            closeModal();
        }
    });
}

function handleHistoryEvents() {
    var historyBtn = document.querySelector('.history_btn');
    if(historyBtn) {
        historyBtn.addEventListener('click', function(){
                historyBtn.style.display = 'none';
                document.querySelector('.history-panel').classList.add('active');
            wmdPageLink('ai-search_history');
            if(Object.keys(groupedConversations).length < 1) {
                // Generate token if not available before fetching history
                if(!_vars.token) {
                    difyApi.generateToken().then(function(data){
                        if(data && data.token) {
                            _vars.token = 'Bearer ' + data.token;
                        }
                        return difyApi.getAllHistory();
                    }).then(function(response) {
                        renderHistoryList(response);
                    }).catch(function(error) {
                        console.log("Token generation or history fetch failed");
                    });
                } else {
                    difyApi.getAllHistory().then(function(response) {
                        renderHistoryList(response);
                    });
                }
            }
        });

        document.querySelector('.history_close_btn').addEventListener('click', function(){
            historyBtn.style.display = 'flex';
            document.querySelector('.history-panel').classList.remove('active');
        });

        // Handle action menu clicks
        document.addEventListener('click', function(e) {
            var actionMenu = e.target.closest('.action-menu');
            if (actionMenu) {
                e.stopPropagation();
                var actions = actionMenu.nextElementSibling;
                // Close other open dropdowns
                document.querySelectorAll('.action-dropdown').forEach(function(dropdown) {
                    if (dropdown !== actions) {
                        dropdown.parentElement.classList.remove('active');
                    }
                });
                actionMenu.parentElement.classList.toggle('active');
                
                // Only scroll into view if dropdown is now active and not fully visible
                if (actionMenu.parentElement.classList.contains('active')) {
                    // Check if dropdown is in viewport
                    var dropdownRect = actions.getBoundingClientRect();
                    var viewportHeight = window.innerHeight;
                    var isFullyVisible = dropdownRect.top >= 0 && dropdownRect.bottom <= viewportHeight;
                    
                    if (!isFullyVisible) {
                        actions.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                }
            } else if (!e.target.closest('.action-dropdown')) {
                // Close all dropdowns when clicking outside
                document.querySelectorAll('.conversation-actions').forEach(function(action) {
                    action.classList.remove('active');
                });
            }
        });

        // Handle rename action
        document.addEventListener('click', function(e) {
            if (e.target.classList.contains('rename-action')) {
                e.stopPropagation();
                var conversationItem = e.target.closest('.conversation-item');
                var threadId = conversationItem.getAttribute('data-thread-id');
                var titleElement = conversationItem.querySelector('.conversation-title');
                var currentTitle = titleElement.textContent.trim();
                
                // Close the action dropdown
                conversationItem.querySelector('.conversation-actions').classList.remove('active');

                // Create rename input
                var input = document.createElement('input');
                input.type = 'text';
                input.value = currentTitle;
                input.className = 'rename-input';
                input.style.cssText = 
                    'width: calc(100% - 40px);' +
                    'padding: 4px 8px;' +
                    'border: 1px solid #064AA7;' +
                    'border-radius: 4px;' +
                    'font-size: 14px;' +
                    'outline: none;';

                // Replace title with input
                titleElement.style.display = 'none';
                titleElement.insertAdjacentElement('afterend', input);
                input.focus();
                wmdPageLink('ai-search_rename-conv', this);
                
                // Handle input events
                input.addEventListener('keyup', function(event) {
                    if (event.key === 'Enter') {
                        var newTitle = this.value.trim();
                        if (newTitle && newTitle !== currentTitle) {
                            difyApi.renameThread(threadId, newTitle).then(function(response) {
                                if (response) {
                                    titleElement.textContent = newTitle;
                                    wmdPageLink('ai-search_rename-conv-conf', this);
                                }
                            }).catch(function(error) {
                                console.error('Failed to rename thread:', error);
                            });
                        }
                        cleanup();
                    } else if (event.key === 'Escape') {
                        cleanup();
                    }
                });

                input.addEventListener('blur', cleanup);

                function cleanup() {
                    input.remove();
                    titleElement.style.display = '';
                    conversationItem.querySelector('.conversation-actions').classList.remove('active');
                }
            }
        });

        // Handle delete action
        document.addEventListener('click', function(e) {
            if (e.target.classList.contains('delete-action')) {
                e.stopPropagation();
                var conversationItem = e.target.closest('.conversation-item');
                var threadId = conversationItem.getAttribute('data-thread-id');
                var conversationTitle = conversationItem.querySelector('.conversation-title').textContent.trim();
                
                // Close the action dropdown
                conversationItem.querySelector('.conversation-actions').classList.remove('active');
                wmdPageLink('ai-search_delete-conv', e.target);
                
                // Show delete confirmation modal
                showDeleteConfirmationModal(threadId, conversationTitle, conversationItem);
            }
        });
    }
}

module.exports = {
    handleHistoryEvents: handleHistoryEvents,
    renderHistoryInChatInterface: renderHistoryInChatInterface
};
